import * as React from 'react';
import { buildClassName } from 'utils/build-class-name';
import styles from './label.module.scss';

const Label = React.forwardRef<
  React.ElementRef<'label'>,
  React.LabelHTMLAttributes<HTMLLabelElement>
>(({ className, ...props }, ref) => (
  <label ref={ref} className={buildClassName(styles.label, className)} {...props} />
));
Label.displayName = 'Label';

export { Label };
